import type { GetPlanOverviewResponse } from '@vy/api-definition';
import { GetPlanOverviewResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function usePlanOverview(planId: string, options?: CustomUseQueryOptions<GetPlanOverviewResponse>) {
  const privateApi = getPrivateApi();

  return useQuery(
    queryKeys.plansOverviews(planId),
    async () => {
      const getPlanOverviewResponse = await privateApi.getPlanOverview({
        planId,
      });

      return GetPlanOverviewResponseSchema.parse(getPlanOverviewResponse);
    },
    options,
  );
}
